/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `static` - 정적
 * `slow_zoom_in` - 느린 줌인
 * `slow_zoom_out` - 느린 줌아웃
 * `slow_pan_left` - 느린 좌측 패닝
 * `slow_pan_right` - 느린 우측 패닝
 * `slow_pan_up` - 느린 상단 패닝
 * `slow_pan_down` - 느린 하단 패닝
 * `tracking_shot` - 트래킹 샷
 * `orbit` - 궤도 회전
 * `dolly_in` - 돌리 인
 * `dolly_out` - 돌리 아웃
 */
export type CameraMovementEnum =
  (typeof CameraMovementEnum)[keyof typeof CameraMovementEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CameraMovementEnum = {
  static: "static",
  slow_zoom_in: "slow_zoom_in",
  slow_zoom_out: "slow_zoom_out",
  slow_pan_left: "slow_pan_left",
  slow_pan_right: "slow_pan_right",
  slow_pan_up: "slow_pan_up",
  slow_pan_down: "slow_pan_down",
  tracking_shot: "tracking_shot",
  orbit: "orbit",
  dolly_in: "dolly_in",
  dolly_out: "dolly_out",
} as const;
